import reportError from "@/utils/reportError"

export function saveToLocalStorage(key, data) {
  try {
    localStorage.setItem(key, JSON.stringify(data))
  } catch (error) {
    reportError(error, { context: "LocalStorageHelper.saveToLocalStorage", key })
    console.error("Error saving to localStorage:", error)
  }
}

export function loadFromLocalStorage(key) {
  try {
    return JSON.parse(localStorage.getItem(key))
  } catch (error) {
    reportError(error, { context: "LocalStorageHelper.loadFromLocalStorage", key })
    console.error("Error loading from localStorage:", error)
    return null
  }
}
